
const Responses = () => {
  return (
    <></>
  );
};

export default Responses;
